import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const CROP_AREA_ASPECT = 1;

const PreviewContainerWrapper = styled.div`
  position: relative;
  box-sizing: ${({ $borderBoxWidth }) =>
    $borderBoxWidth ? "border-box" : "content-box"};
  width: ${({ width }) => width};
  overflow: hidden;
  border-radius: ${({ cropShape }) => (cropShape === "round" ? "50%" : "0")};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? (theme?.colors?.[backgroundColor] ?? backgroundColor)
      : "transparent"};
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  border: ${({ borderSize }) => borderSize} solid rgb(255, 255, 255);
`;

const PreviewContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: ${({ cropShape }) => (cropShape === "round" ? "50%" : "0")};
`;

const PreviewImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
  height: auto;
  width: calc(100% + 0.5px);
`;

const Preview = ({
  croppedArea,
  imageSrc,
  cropShape,
  width = "100px",
  backgroundColor = "white",
  borderSize = "6px",
  /** Avatar modal preview only: width includes border so outer size matches EditMode crop (400px). */
  borderBoxWidth = false,
}) => {
  const scale = 100 / (croppedArea?.width || 1);
  const transform = {
    x: `${-(croppedArea?.x ?? 0) * scale}%`,
    y: `${-(croppedArea?.y ?? 0) * scale}%`,
    scale,
    width: "calc(100% + 0.5px)",
    height: "auto",
  };

  const imageStyle = {
    transform: croppedArea
      ? `translate3d(${transform.x}, ${transform.y}, 0) scale3d(${transform.scale},${transform.scale},1)`
      : "none",
    width: transform.width,
    height: transform.height,
  };

  return (
    <PreviewContainerWrapper
      $borderBoxWidth={borderBoxWidth}
      width={width}
      cropShape={cropShape}
      backgroundColor={backgroundColor}
      borderSize={borderSize}
    >
      <PreviewContainer
        width={width}
        className="output"
        cropShape={cropShape}
        style={{
          paddingBottom: `${100 / CROP_AREA_ASPECT}%`,
        }}
      >
        <PreviewImage src={imageSrc} alt="" style={imageStyle} />
      </PreviewContainer>
    </PreviewContainerWrapper>
  );
};

Preview.propTypes = {
  /** When omitted, image is shown uncropped (same as before first crop). */
  croppedArea: PropTypes.object,
  imageSrc: PropTypes.string.isRequired,
  cropShape: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  borderSize: PropTypes.string,
  borderBoxWidth: PropTypes.bool,
};

export default Preview;
